<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-del="delMoney" @row-save="handleSave"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <div style="display: flex;">
            <div>
              <el-button type="primary" size="small" plain @click.stop="handleAdd()"
                v-if="permission.JOINS_SALES_CLOUD_ADDMONEY_INSERT" icon="el-icon-circle-plus-outline">新增</el-button>
              <el-button type="danger" size="small" plain @click.stop="handleDelete()"
                v-if="permission.JOINS_SALES_CLOUD_ADDMONEY_DEL" icon="el-icon-circle-close">删除</el-button>
              <el-button type="success" size="small" plain @click.stop="downloadExcelAddMoney"
                icon="el-icon-download">下载Excel</el-button>
            </div>
            <!--验证Excel并返回文件流 -->
            <div>
              <el-button type="warning" size="small" plain @click.stop="openUploadDialog('type1')"
                icon="el-icon-upload">
                验证Excel
              </el-button>
            </div>
            <div>
              <el-button type="info" size="small" plain @click.stop="openUploadDialog('type2')" icon="el-icon-upload">
                生成数据表格
              </el-button>
            </div>

          </div>
        </template>
        <!--右侧菜单操作 -->
        <template slot-scope="scope" slot="menuRight">
          <el-button type="success" size="small" plain @click.stop="openUploadDialog('type3')" icon="el-icon-upload"
            round>
            导入Excel
          </el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="danger" icon="el-icon-delete" size="small" plain @click.stop="delMoney(scope.row)"
            v-if="permission.JOINS_SALES_CLOUD_ADDMONEY_DEL">删除</el-button>
        </template>
        <template slot-scope="scope" slot="chooseClientTypeForm">
          <el-select v-model="currClientType" filterable="filterable" clearable @change="chooseClientType"
            placeholder="请选择客户端类型">
            <el-option v-for="item2 in chooseClientTypes" :key="item2.value" :label="item2.label"
              :value="item2.value"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="showNameForm">
          <el-input v-model="showName" disabled placeholder=""></el-input>
        </template>
        <template slot-scope="scope" slot="amountForm">
          <div class="el-form-item__content">
            <el-input placeholder="请输入金额" v-model="amount1" maxlength="18" @blur="checkAmount"></el-input>
            <div class="el-form-item__error" v-if="flag">{{ infoMessage }}</div>
          </div>
        </template>
        <template slot-scope="scope" slot="mobileForm">
          <el-input v-model="inputNumber" maxlength="11" placeholder="请输入账号"></el-input>
        </template>
        <template slot-scope="scope" slot="url">
          <viewer :images="formmaterImage(scope.row.url)">
            <img v-for="src in formmaterImage(scope.row.url)" :src="src" :key="src" width="30" />
          </viewer>
        </template>
        <template slot-scope="scope" slot="urlForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList" :http-request="fnUploadDescribeImgs" :show-file-list="false">
            <div v-if="'' != describeImgs" class="el-upload el-upload--picture-img">
              <img v-for="describeImg of describeImgs" :key="describeImg.value" :src="describeImg"
                style="width: 200px;" />
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
      </avue-crud>
      <el-dialog :visible.sync="payMoneyDialog" title="支付失败" center width="450px">
        <div style="font-size: 14px">
          <p>您好，您的账户余额不足请更换支付方式或充值后再进行支付！</p>
          <div style="display: flex;justify-content:center;margin-top:40px">
            <el-radio v-model="radio" label="BALANCE" @change="rechargeWayBALANCE">账户余额</el-radio>
            <el-radio v-model="radio" label="WX_PAY" @change="rechargeWayWX_PAY">微信支付</el-radio>
          </div>
        </div>
        <div class="typeButton">
          <el-button round size="mini" @click="immediatePayment">&nbsp;&nbsp;&nbsp;立即支付&nbsp;&nbsp;&nbsp;</el-button>
          <el-button round type="danger" size="mini"
            @click="rechargeDialog = true">&nbsp;&nbsp;&nbsp;去充值&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <template>
        <el-dialog :visible.sync="rechargeDialog" title="充值" center width="1000px">
          <div class="remittance"
            style="font-size: 14px;display: flex;flex-flow: column nowrap; align-items: flex-start;margin-left:205px">
            <div class="recharge">
              <span style="width:130px;text-align:left;">请输入充值金额:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="number" placeholder="请输入充值金额" v-model="rechargeMoney" style="width:215px"></el-input>
            </div>
            <div style="display: flex;justify-content:flex-start;">
              <span style="width:130px;text-align:left;">支付方式:</span>
              <div>
                <el-radio v-model="payRadio" label="OFFLINE_REMIT" @change="rechargeWayOFFLINE_REMIT">线下汇款</el-radio>
                <el-radio v-model="payRadio" label="WX_PAY" @change="rechargeWayWX_PAY">微信支付</el-radio>
              </div>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width:130px;text-align:left;">汇款账户名称:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="text" placeholder="请输入汇款账户名称" v-model="remittanceAccountName"
                style="width:215px"></el-input>
              <i
                style="font-style:normal;display: inline;font-size: 12px;color:red">&nbsp;&nbsp;个人储蓄卡请填写持卡人姓名，对公账户请填写账户名称</i>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width:130px;text-align:left;">汇款账户:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="text" placeholder="请输入汇款账户" v-model="remittanceAccount" style="width:215px"></el-input>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'"
              style="display: flex;justify-content:flex-start;">
              <span style="width:130px;text-align:left;">汇款银行:</span>
              <div>
                <el-select placeholder="请输入汇款银行" v-model="currBank" style="width:215px">
                  <el-option v-for="item in remittanceBank" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'" style=" margin-bottom:40px ">
              <span style="width:130px;text-align:left; ">凭证:</span>
              <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                :file-list="fileList1" :http-request="fnUploadremittanceImgs" :show-file-list="false">
                <div v-if="'' != remittanceImgs" class="el-upload el-upload--picture-img">
                  <img v-for="remittanceImg of remittanceImgs" :key="remittanceImg.value" :src="remittanceImg"
                    style="width: 200px;" />
                </div>
                <div v-else class="el-upload el-upload--car-two">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="el-upload__tip">
                  请上传汇款回单凭证，只能上传jpg/png图片，且不超过500kb
                </div>
              </el-upload>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">账户名称:</span>
              成都聚家科技有限公司
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">账户号码:</span>
              4402209109100103208
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">开户银行:</span>
              中国工商银行股份有限公司成都天顺路支行
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">汇款提示:</span>
              请避免北京时间18：00-00：00进行汇款，否则受银行出账时间影响，可能出现延迟一天到账情况。
            </div>
          </div>
          <div class="remittanceButton">
            <el-button round size="mini" @click="balancePayment">&nbsp;&nbsp;&nbsp;立即充值&nbsp;&nbsp;&nbsp;</el-button>
            <el-button round type="danger" size="mini"
              @click="rechargeDialog = false">&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          </div>
        </el-dialog>
      </template>
      <template>
        <el-dialog title="二维码支付" :visible.sync="QRCodeDialog" align="center">
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
    </basic-container>
    <el-dialog :visible.sync="uploadDialogVisible" :title="title" width="30%" :close-on-click-modal="false">
      <el-form :model="uploadForm" :rules="uploadRules" ref="uploadFormRef" label-width="100px">
        <el-form-item label="用户类型" prop="clientType">
          <el-select v-model="uploadForm.clientType" placeholder="请选择用户类型">
            <el-option label="水工" value="JOINS_ENGINEER"></el-option>
            <el-option label="商家" value="JOINS_MERCHANT"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件">
          <el-upload class="upload-demo" ref="upload" :action="fileUrl" :limit="1" :headers="headers"
            accept=".xls,.xlsx,csv" :on-remove="handleRemoveFile" :file-list="fileList" :auto-upload="false">
            <el-button type="success" size="small" round>导入Excel<i
              class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx/csv文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelUpload">取消</el-button>
        <el-button type="primary" @click="handleUpload">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addMoneyOption } from "@/const/salesCloud/addMoneyOption";
import {
  findpreFilter,
  immediatePay,
  addBalance,
  delBalance,
  findUserList,
  uploadFile,
  v1BalanceExcel,
  downloadCheckingXls,
  downloadExcelData,
} from "@/api/salesCloud/addMoney";
import { DIC } from "@/const/dic";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { getCeiling } from "@/api/salesCloud/ceiling";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import VueQr from "vue-qr";
import oss from "ali-oss";
import md5 from "js-md5";
export default {
  name: "addMoney",
  components: {
    VueQr,
  },
  data() {
    return {
      uploadDialogVisible: false,
      currentUploadType: '',
      uploadForm: {
        clientType: ''
      },
      uploadFormFile: null,
      fileList: [],
      uploadRules: {
        clientType: [
          { required: true, message: '请选择用户类型', trigger: 'change' },
        ],
      },
      title: "验证Excel",
      fileUrl: "https://huijia.joinstech.com", //上传文件的域名地址
      fileListExcel: [], //文件列表
      showFileList: false, //文件列表是否显示,默认不显示
      headers: {
        "Content-Type": "multipart/form-data",
      },
      action: "",
      files: [], // 选择文件
      tableOption: addMoneyOption, //表格设置属性
      tableData: [], //表格的数据
      tableLoading: false,
      payMoneyDialog: false,
      QRCodeDialog: false,
      rechargeDialog: false,
      rechargeWay: "",
      showName: "",
      paymentTask: {},
      // mobiles: [],
      currClientType: {},
      chooseClientTypes: DIC.WALLET_USER_TYPE,
      // currMobile: {},
      inputNumber: "",
      radio: "BALANCE",
      payRadio: "OFFLINE_REMIT",
      rechargeMoney: "",
      remittanceAccountName: "",
      remittanceAccount: "",
      currBank: "",
      remittanceBank: DIC.BANK_LIST,
      config: { value: "" },
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      fileList1: [],
      describeImgs: [],
      remittanceImgs: [],
      amount1: "",
      infoMessage: "",
      ceiling: "",
      integralValue: "",
      flag: false,
    };
  },
  created() {
    getCeiling().then((res) => {
      // console.log(res);
      if (res.code == "200") {
        this.ceiling = res.data;
      }
    });
    this.handleList();
  },
  watch: {
    inputNumber(newMobile) {
      if (newMobile == "") {
        return;
      }
      if (newMobile.length == 11) {
        let params = {};
        params.type = this.currClientType;
        params.mobile = newMobile;
        if (newMobile.length == 11) {
          this.$refs.crud.$refs.tableForm.form.mobile = newMobile;
        } else {
          this.$refs.crud.$refs.tableForm.form.mobile = "";
        }
        findUserList(params).then((res) => {
          if (res.code == "200") {
            let data = JSON.parse(res.data);
            // console.log(data);
            this.$message({
              showClose: false,
              // message: data[0].realName,
              duration: 1,
              type: "success",
            });
            this.$nextTick(() => {
              this.showName = data[0].realName;
              // console.log(this.showName);
            });
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            setTimeout(() => {
              this.$refs.crud.$refs.tableForm.form.mobile = "";
            }, 1000);
          }
        });
      } else {
        this.$refs.crud.$refs.tableForm.form.mobile = "";
      }
      // console.log(oldMobile);
    },
  },
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    openUploadDialog(type) {
      this.currentUploadType = type;
      if (type == 'type1') {
        this.title = '验证Excel';
      } else if (type == 'type2') {
        this.title = '生成数据表格';
      } else if (type == 'type3') {
        this.title = '导入Excel';
      }
      this.uploadDialogVisible = true;
    },
    handleRemoveFile(file) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid);
      this.uploadFormFile = null;
    },
    cancelUpload() {
      this.uploadDialogVisible = false;
      this.uploadForm = {
        clientType: ''
      };
      this.fileList = [];
    },
    handleUpload() {
      if (!this.$refs.upload.uploadFiles[0]) {
            this.$message.error('请上传文件!');
            return;
          }
      this.$refs.uploadFormRef.validate(valid => {
        if (valid) {
          this.uploadForm.file = this.$refs.upload.uploadFiles[0].raw;
          console.log('index.vue ~ line: 382 ~ this.uploadForm ->', this.uploadForm);
          if (this.currentUploadType == 'type1') {
            //验证Excel文件返回文件流下载
            this.verifyUploadFile(this.uploadForm.file, this.uploadForm.clientType);
          } else if (this.currentUploadType == 'type2') {
            //下载Excel文件
            this.downloadExcelData(this.uploadForm.file, this.uploadForm.clientType);
          } else if (this.currentUploadType == 'type3') {
            //上传Excel文件
            this.uploadFile(this.uploadForm.file, this.uploadForm.clientType);
          }
          this.uploadForm = {
            clientType: '',
            file: null,
          };
          this.fileList = [];
          this.$message.success(`上传成功: ${this.currentUploadType}`);
          this.uploadDialogVisible = false;
        }
      });
    },
    //覆盖默认的上传行为,可以自定义上传的实现
    uploadFile(file, clientType) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('file_name', file.name);
      formData.append('clientType', clientType);
      formData.append('businessType', 3);
      /* // FormData对象不能直接通过console.log打印内容，需要特殊处理
      console.log('formData内容:');
      // 方法1: 使用entries()遍历FormData
      for (let pair of formData.entries()) {
        // 对于file类型不打印具体内容，只打印文件名
        if (pair[0] === 'file' && pair[1] instanceof File) {
          console.log(pair[0] + ': ' + pair[1].name);
        } else {
          console.log(pair[0] + ': ' + pair[1]);
        }
      } */
     //请求接口
      uploadFile(formData).then((res) => {
        if (res.code == "200") {
          this.$message.success(res.message ? res.message : "上传成功");
          this.handleList();
        } else {
          this.$confirm(res.message, "错误提示", {
            confirmButtonText: "关闭",
            showCancelButton: false,
            type: "error",
            confirmButtonClass: "el-button--danger",
            customClass: 'myMessage-box',
          });
        }
      });
    },
    //验证Excel文件返回文件流下载
    verifyUploadFile(file, clientType) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('file_name', file.name);
      formData.append('clientType', clientType);
      // console.log('formData::: ', formData);
      downloadCheckingXls(formData).then((response) => {
        // 提取文件名
        const filename = "未导入人员电话.xlsx"
        // 将二进制流转为blob
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename))
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob)
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', decodeURI(filename))
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
          }
          // 挂载a标签
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL)
          this.handleList();
        }
      });
    },
    //下载Excel文件
    downloadExcelData(file, clientType) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('file_name', file.name);
      formData.append('clientType', clientType);
      downloadExcelData(formData).then((response) => {
        const filename = formData.get("file_name");
        // 将二进制流转为blob
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename))
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob)
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', decodeURI(filename))
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
          }
          // 挂载a标签
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL)
          this.handleList();
        }
      });
    },
    checkAmount() {
      this.$refs.crud.$refs.tableForm.form.amount = this.amount1;
      if (this.ceiling) {
        if (parseFloat(this.amount1) > parseFloat(this.ceiling)) {
          this.flag = true;
          this.infoMessage = "金额不能超过上限" + this.ceiling;
          this.$refs.crud.$refs.tableForm.form.amount = "";
        } else {
          this.flag = false;
        }
      }
      // console.log(this.amount1);
      if (this.amount1 < 0) {
        this.amount1 = 0;
      }
    },
    remoteMethod(query) {
      if (query.length > 10) {
        // console.log(query);
      }
    },
    chooseMobile() {
      // console.log(this.currMobile);
      if (this.currMobile.mobile.length > 10) {
        // console.log(this.currMobile.mobile);
      }
      this.$refs.crud.$refs.tableForm.form.mobile = this.currMobile.mobile;
      // console.log(this.$refs.crud.$refs.tableForm.form);
    },
    chooseClientType() {
      // console.log(this);
      this.inputNumber = "";
      let params = {};
      params.type = this.currClientType;
      // console.log(this.currClientType);
      this.$refs.crud.$refs.tableForm.form.chooseClientType = this.currClientType;
    },
    rechargeWayBALANCE() {
      this.paymentTask.rechargeWay = "BALANCE";
      // console.log(this.paymentTask.rechargeWay);
    },
    rechargeWayWX_PAY() {
      this.paymentTask.rechargeWay = "WX_PAY";
      // console.log(this.paymentTask.rechargeWay);
    },
    rechargeWayOFFLINE_REMIT() {
      this.paymentTask.rechargeWay = "OFFLINE_REMIT";
      // console.log(this.paymentTask.rechargeWay);
    },
    changeStatus() {
      // console.log(this);
    },
    balancePayment() {
      let params = {};
      params.money = this.rechargeMoney;
      params.rechargeType = "BALANCE";
      params.payType = this.payRadio;
      params.openingUser = this.remittanceAccountName;
      params.bankNumber = this.remittanceAccount;
      params.bankName = this.currBank;
      params.url = this.remittanceImgs + "";
      // console.log(params);
      if (params.payType == "OFFLINE_REMIT") {
        if (
          params.money &&
          params.openingUser &&
          params.bankNumber &&
          params.bankName &&
          params.url
        ) {
          addBalance(params).then((res) => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message:
                  "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                type: "success",
              });
              this.rechargeDialog = false;
              this.payMoneyDialog = false;
              setTimeout(() => {
                this.$router.push({ name: "账号明细管理" });
              }, 5000);
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完善输入信息",
            type: "error",
          });
        }
      } else {
        addBalance(params).then((response) => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            // console.log(data);
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then((res) => {
              // console.log(res);
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function () {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "支付成功",
                      type: "success",
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.rechargeDialog = false;
                    _this.$router.push({ name: "账号明细管理" });
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then((res) => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function () {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "支付成功",
                              type: "success",
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.$router.push({ name: "账号明细管理" });
                            // console.log("进来了");
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error",
                          });
                          // console.log("超时", new Date());
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error",
                        });
                        // console.log("超时", new Date());
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            // console.log("集合：" + this.config.value);
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
            //???下面的感觉没用
            this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    immediatePayment() {
      let row = this.paymentTask;
      if (row.rechargeWay == "BALANCE") {
        immediatePay(row).then((res) => {
          // console.log("res", res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "新增成功",
              type: "success",
            });
            this.handleList();
          } else if (res.code == "22001002") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            setTimeout(() => {
              this.payMoneyDialog = true;
            }, 1500);
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            this.handleList();
          }
        });
      } else {
        row.rechargeWay = "WX_PAY";
        // console.log(row);
        immediatePay(row).then((response) => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            // console.log(data);
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then((res) => {
              // console.log(res);
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function () {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "支付成功",
                      type: "success",
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.done();
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then((res) => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function () {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "支付成功",
                              type: "success",
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error",
                          });
                          // console.log("超时", new Date());
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error",
                        });
                        // console.log("超时", new Date());
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            // console.log("集合：" + this.config.value);
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
            //???下面的感觉没用
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    clean() {
      this.describeImgs = [];
      this.remittanceImgs = [];
      this.rechargeMoney = "";
      this.paymentTask = {};
      // this.chooseClientTypes = DIC.WALLET_USER_TYPE;
      this.currClientType = "";
      this.inputNumber = "";
      this.showName = "";
      this.amount1 = "";
      this.flag = false;
    },
    handleAdd() {
      // console.log(this);
      this.prices = [];
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleSave(row, done) {
      // console.log(row);
      // console.log(this.amount1);

      // return;
      if (
        (this.amount1 <= 0 || this.amount1 == "") &&
        (row.integral <= 0 || row.integral == "")
      ) {
        this.$message({
          showClose: true,
          message: "金额与积分不能同时为空或同时为零",
          type: "error",
        });
        done();
        // this.$refs.crud.rowAdd();
        return;
      }
      if (!this.ceiling) {
        this.$message({
          showClose: true,
          message: "添加失败，未设置金额上限，请联系管理员设置。",
          type: "error",
        });
        done();
        // this.$refs.crud.rowAdd();
        return;
      }

      row.url = this.describeImgs.join(",");
      row.type = "INCOME";
      row.clientType = this.currClientType;
      row.remarks = row.remarks.replace(/(^\s*)|(\s*$)/g, "");
      if (!this.amount1) {
        this.amount1 = 0;
      }
      row.amount = this.amount1;
      //row.remarks = "充值";
      // console.log("row", row);
      this.paymentTask = row;
      if (row.rechargeWay == "BALANCE") {
        // console.log(row);
        immediatePay(row).then((res) => {
          // console.log("res", res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "新增成功",
              type: "success",
            });
            this.handleList();
            done();
          } else if (res.code == "22001002") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            setTimeout(() => {
              this.payMoneyDialog = true;
              done();
            }, 1500);
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            this.handleList();
            done();
          }
        });
      } else {
        immediatePay(row).then((response) => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            // console.log(data);
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then((res) => {
              // console.log(res);
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function () {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "支付成功",
                      type: "success",
                    });
                    _this.handleList();
                    done();
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then((res) => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function () {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "支付成功",
                              type: "success",
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            done();
                            // console.log("进来了");
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error",
                          });
                          done();
                          // console.log("超时", new Date());
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error",
                        });
                        done();
                        // console.log("超时", new Date());
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
                done();
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            // console.log("集合：" + this.config.value);
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
            //???下面的感觉没用
            done();
            this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    handleDelete() {
      let ids = this.$refs.crud.tableSelect.map((item) => {
        return item.id;
      });
      // console.log(ids);
      delBalance(ids).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: "请选择你要操作的数据",
            type: "error",
          });
          this.handleList();
        }
        // console.log("res", res);
      });
    },
    delMoney(row) {
      let ids = row.id;
      // console.log(row);
      delBalance(ids).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
          this.handleList();
        }
        // console.log("res", res);
      });
    },
    formmaterImage(row) {
      let str = new Array();
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      findpreFilter(params).then((res) => {
        let data = JSON.parse(res.data);
        // console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.createTimeStart = params.startDate_endDate[0];
        params.createTimeEnd = params.startDate_endDate[1];
      } else {
        delete params.createTimeStart;
        delete params.createTimeEnd;
      }
      this.downloadData = params;
      // console.log(params);
      findpreFilter(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      // console.log(page);
      this.downloadData = params;
      findpreFilter(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      // console.log(params);
      findpreFilter(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findpreFilter(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs);
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },
    async fnUploadremittanceImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs);
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.remittanceImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },

    // 文件上传类型
    beforeUpload(file) {
      // console.log("beforeUpload", file);
      let regExp = file.name.replace(/.+\./, "");
      let lower = regExp.toLowerCase(); //把大写字符串全部转为小写字符串
      let suffix = ["xls", "xlsx"];
      if (suffix.indexOf(lower) === -1) {
        return this.$message.warning("请上传后缀名为 xls、xlsx 的附件 !");
      }
      let isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        return this.$message.error("请上传文件大小不能超过 2MB 的附件 !");
      }
    },
    //文件超出个数限制时的钩子
    onExceed(files, fileList) {
      // console.log("onExceed-files", files);
      // console.log("onExceed-fileList", fileList);
      // return this.$message.warning(`只能选择${this.limitNum}个文件,当前共选择了${files.length + fileList.length}个`)
    },
    /*     //覆盖默认的上传行为,可以自定义上传的实现
        uploadFile(item) {
          // console.log("uploadFile", item);
          //this.tableLoading = true;
          let formData = new FormData();
          formData.append("file", item.file);
          formData.append("file_name", item.file.name);
          // 用户点击确认才会上传
          this.$confirm("是否确认上传该文件?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              // //请求接口
              uploadFile(formData).then((res) => {
                if (res.code == "200") {
                  this.$message.success(res.message ? res.message : "上传成功");
                  this.handleList();
                } else {
                  this.$confirm(res.message, "错误提示", {
                    confirmButtonText: "关闭",
                    showCancelButton: false,
                    type: "error",
                    confirmButtonClass: "el-button--danger",
                    customClass: 'myMessage-box',
                  });
                }
                // this.$message.success(res.message?res.message:"上传成功,请间隔几分钟后刷新页面查看");
                // console.log("uploadFile-res", res);
                // this.handleList();
              });
            })
            .catch((res) => {
              this.$message.info("已取消上传");
              this.tableLoading = false;
            });
        },
        //验证Excel文件返回文件流下载
        verifyUploadFile(item) {
          // console.log("verifyUploadFile", item);
          this.tableLoading = true;
          let formData = new FormData();
          formData.append("file", item.file);
          formData.append("file_name", item.file.name);
          //window.open("https://city.joinstech.com:8000/joins-wallet/v1/balance/downloadCheckingXls1");
          // //请求接口
          downloadCheckingXls(formData).then((response) => {
            // 提取文件名
            const filename = "未导入人员电话.xlsx"
            // 将二进制流转为blob
            const blob = new Blob([response.data], { type: 'application/octet-stream' })
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(filename))
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob)
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement('a')
              tempLink.style.display = 'none'
              tempLink.href = blobURL
              tempLink.setAttribute('download', decodeURI(filename))
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
              }
              // 挂载a标签
              document.body.appendChild(tempLink)
              tempLink.click()
              document.body.removeChild(tempLink)
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL)
              this.handleList();
            }
          });
        },
        //下载Excel文件
        downloadExcelData(item) {
          // console.log("downloadExcelData", item);
          this.tableLoading = true;
          let formData = new FormData();
          formData.append("file", item.file);
          formData.append("file_name", item.file.name);
          //请求接口
          downloadExcelData(formData).then((response) => {
            const filename = item.file.name
            // 将二进制流转为blob
            const blob = new Blob([response.data], { type: 'application/octet-stream' })
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(filename))
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob)
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement('a')
              tempLink.style.display = 'none'
              tempLink.href = blobURL
              tempLink.setAttribute('download', decodeURI(filename))
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
              }
              // 挂载a标签
              document.body.appendChild(tempLink)
              tempLink.click()
              document.body.removeChild(tempLink)
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL)
              this.handleList();
            }
          });
        }, */
    downloadExcelAddMoney() {
      let params = this.downloadData;
      // let url = `/joins-wallet/v1/balance/excel?`;
      // excelaxios(url, params);
      v1BalanceExcel(params).then((res) => {
        window.open(res);
      });
    },
  },
};
</script>
<style lang="scss">
.myMessage-box {
  width: 500px !important;

  .el-message-box__title {
    // 红色字体
    color: #f56c6c !important;
    font-size: 16px !important;
    font-weight: bold !important;
  }

  .el-button--danger {
    background-color: #f56c6c !important;
    border-color: #f56c6c !important;
  }
}

.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.remittance {
  .recharge {
    margin-top: 10px;
  }
}

.remittanceButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 150px;
}
</style>
<style>
.avue-crud__right {
  display: flex;
}
</style>
